export default "__VITE_ASSET__7LQJ7IhV__"